import { ADMIN_WALLET_ADDRESS, IS_PROD } from 'util/constants';

export const get_all_nfts_from_account = `
import MetaverseMarket from ${ADMIN_WALLET_ADDRESS}
import NonFungibleToken from ${
  IS_PROD ? '0x1d7e57aa55817448' : '0x631e88ae7f1d7c20'
}

pub fun main(from: Address): &{UInt64: NonFungibleToken.NFT}?{
    return MetaverseMarket.getAllNftsFromAccount(from)
}
`;
